export default __webpack_public_path__ + "static/refinansiering-13b62332fdc57be427471d3727e16949.png";